export default {
  data: [
    {
      dairy: false,
      favorite: false,
      flavor: 'Almond',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Avocado',
      premium: true
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Banana',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Blueberry',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Cantaloupe',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Cappuccino',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Caramel',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Cherry',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Chocolate',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Chocolate Mint',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Chocolate Peanut',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Coconut',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Coffee',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Coffee Toffee',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Cookies \'n Cream',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Cranberry',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Ginger',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Grape',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Grapefruit',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Green Apple',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Green Bean',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Guava',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Honey Dew',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Kiwi',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Kumquat',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Lavender',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Lemon',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Lychee',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Matcha Green Tea',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Mango',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Papaya',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Passion',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Peach',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Pear',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Peppermint',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Pina Colada',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Pineapple',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Pistachio',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Pomegranate',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Pumpkin',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Raspberry',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Red Bean',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Red Velvet',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Rose',
      premium: true
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Royal',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Sesame',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Sour Plum',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Strawberry',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Strawberry Yogurt',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Tangerine',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Taro',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Thai',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'Vanilla',
      premium: false
    },
    {
      dairy: true,
      favorite: false,
      flavor: 'White Chocolate',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Wintermelon',
      premium: false
    },
    {
      dairy: false,
      favorite: false,
      flavor: 'Yogurt',
      premium: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/js/slush_and_snow_flavors.js